import { RefObject } from 'react';

import { useEventListener } from '../useEventListener/useEventListener';

type Handler = (event: MouseEvent) => void;

/**
 * useOnClickOutside
 *
 * https://usehooks-ts.com/react-hook/use-on-click-outside
 * @param ref
 * @param handler
 * @param mouseEvent
 */
export const useOnClickOutside = <T extends HTMLElement = HTMLElement>(
    ref: RefObject<T | undefined>,
    handler: Handler,
    mouseEvent: 'mousedown' | 'mouseup' = 'mousedown',
): void => {
    useEventListener(mouseEvent, (event) => {
        const el = ref?.current;

        // Do nothing if clicking ref's element or descendent elements
        // Have to use an assertion here, see SO https://stackoverflow.com/a/43851475
        if (!el || el.contains(event.target as Node)) {
            return;
        }

        handler(event);
    });
};
